<template>
  <div class=tabella>
      
    <b-alert
      :show="saveerror"
      dismissible
      variant="danger"
      @dismissed="saveerror=0"
      @dismiss-count-down="countDownChanged"
    >
      <p>Errore durante il salvataggio</p>
      <p>{{errordescr}}</p>
    </b-alert>
    <b-modal
      no-close-on-backdrop
      title="Edit record"
      class="modal-danger"
      v-model="editModal"
      @ok="saveentry"
      ok-variant="danger"
    >
      <b-col md="12">
        <b-card>
          <b-form>
            <b-row>
              <b-col md="12">
                <table>
                  <tr v-for="(r) in frow" v-bind:key="r.key" >
                    <td>{{label(r['key'])}}</td>
                    <td>
                      <model-select
                        v-if="r.key=='client_code'"
                        :options="optclients"
                        v-model="r.value"
                        placeholder="selezionare"
                      ></model-select>
                      <model-select
                        v-else-if="r.key=='master' || r.key=='amministrativo' || r.key=='forzata' || r.key=='ro'"
                        :options="optsino"
                        v-model="r.value"
                        placeholder="selezionare"
                      ></model-select>
                      <multi-select
                        v-else-if="r.key=='cross'"
                        :options="foptmacchine(currclient)"
                        :selected-options="r.value!='' ? r.value : []"
                        @select="onMSelect"
                      ></multi-select>
                      <datetime
                        v-else-if="r.key=='data'"
                        :input-class="'form-control'"
                        format="yyyy-MM-dd"
                        v-model="r['value']"
                      ></datetime>
                      <b-form-input
                        v-else-if="r.key=='password'"
                        type="password"
                        v-model="r['value']"
                      ></b-form-input>
                      <b-form-input
                        v-else-if="r.key=='code' && table=='possible_units'"
                        type="text"
                        readonly
                        v-model="r['value']"
                      ></b-form-input>
                      <b-form-input
                        v-else
                        id="nome"
                        type="text"
                        autocomplete="name"
                        v-model="r['value']"
                        :disabled="r.key=='file'"
                      ></b-form-input>
                    </td>
                  </tr>
                </table>
              </b-col>
            </b-row>
          </b-form>
        </b-card>
      </b-col>
    </b-modal>
    <b-modal
      no-close-on-backdrop
      title="Attenzione"
      class="modal-danger"
      v-model="dangerModal"
      @ok="deleteentry"
      ok-variant="danger"
    >Sicuro di voler eliminare la riga ?</b-modal>
    <template v-if="waiting">
        <SemipolarSpinner :animation-duration="2000" :size="65" :color="'#ff1d5e'" />
    </template>
    <template v-else>
        <b-row>
        <div v-if="table=='stati_deroga'">
            <h1>Attenzione</h1>
            Le modifiche fatte a questa tabella possono avere ripercussioni su tutti i progetti passati ed in corso. Procedere solo se si sa <u>esattamente</u> cosa si sta facendo
            <br><br><br>
        </div>
        <div style="overflow-x:auto;width:100%;" class=table>
            <vue-good-table
            @on-row-dblclick="onRowDoubleClick"
            @on-per-page-change="onPageChange"
            :columns="columns"
            :rows="rows"
            styleClass="vgt-table condensed striped bordered"
            :_fixed-header="true"
            :row-style-class="rowStyleClassFn"
            :pagination-options="pagopts"
            :sort-options="{ enabled: true }"
            :search-options="{
                enabled: true,
                trigger: 'key-up', // enter
                skipDiacritics: true,
                //searchFn: mySearchFn,
                placeholder: 'Search',
                //externalQuery: searchQuery
            }"
            >
            <div slot="table-actions">
                <b-button class="add" title="add" @click="newRec" v-if="!$store.getters.ro">
                <v-icon name="plus" scale="1" />
                </b-button>
            </div>
            <template slot="table-column" slot-scope="props">{{label(props.column.label)}}</template>
            <template slot="table-row" slot-scope="props">
                <span v-if="props.column.field == 'actions'">
                <b-button title="edit" @click="edit(props)" v-if="isAdmin && !$store.getters.ro">
                    <v-icon name="edit" scale="1" />
                </b-button>
                <b-button title="delete" @click="delitem(props.formattedRow['id'])" v-if="isAdmin && !$store.getters.ro">
                    <v-icon name="trash" scale="1" />
                </b-button>
                </span>
                <span v-else-if="props.column.field == 'cross'" class="cross">
                <multi-select
                    :options="optmacchine"
                    :selected-options="props.formattedRow[props.column.field]"
                    @select="onMSelect"
                    :isDisabled="true"
                ></multi-select>
                </span>
                <span v-else-if="props.column.field == 'password'">********</span>
                <span
                v-else-if="(props.column.field == 'admin' || props.column.field == 'attiva') && props.formattedRow[props.column.field]"
                >YES</span>
                <span
                v-else-if="(props.column.field == 'admin' || props.column.field == 'attiva') && !props.formattedRow[props.column.field]"
                >NO</span>
                <span
                v-else-if="props.column.field == 'client_code'"
                >{{getclient_code(props.formattedRow[props.column.field])}}</span>
                <span v-else-if="props.column.field.endsWith('url')">
                <lightbox
                    v-bind:thumbnail="baseurl + '/image?path=' + props.formattedRow[props.column.field]"
                    :images="[baseurl + '/image?path=' + props.formattedRow[props.column.field]]"
                ></lightbox>
                </span>
                <span
                v-else-if="props.column.field == 'open'"
                >{{props.formattedRow[props.column.field] ? 'YES' : 'NO'}}</span>
                <span v-else>{{props.formattedRow[props.column.field]}}</span>
            </template>
            </vue-good-table>
        </div>
        </b-row>
    </template>

  </div>
</template>

<script>
import { API } from "@/api.js";
import { SemipolarSpinner } from "epic-spinners";
import { VueGoodTable } from "vue-good-table";
import "vue-good-table/dist/vue-good-table.css";
import { ModelSelect } from "vue-search-select";
import { MultiSelect } from "vue-search-select";
import 'vue-search-select/dist/VueSearchSelect.css'

export default {
  props: ["table", "filter"],
  name: "tabella",
  components: {
    VueGoodTable,
    ModelSelect,
    MultiSelect,
    SemipolarSpinner,
  },
  data: function() {
    this.refresh();
    return {
      waiting: false,
      mountedDone: false, // per gestire il "perpage" che spara anche prima
      saveerror: 0,
      errordescr: "",
      dlmess: "",
      dlnome: "",
      columns: [],
      rows: [],
      baseurl: window.baseurl,
      dangerModal: false,
      editModal: false,
      itemsel: 0,
      row: false,
      optclients: [],
      optsino: [{ value: false, text: "NO" }, { value: true, text: "YES" }], // open si/no
      optmacchine: [], // reparti
      crossutemacchine: [],
    };
  },
  mounted: async function() {
    // console.log("mounted")
    let mask = this.$store.getters.mask 
    this.optclients = (await API.getClients()).map(r => ({text: mask ? "*****" : r.name, value:r.code})).sort((a,b) => a.text.localeCompare(b.text))
    // console.log("this.optclients",this.optclients)
    this.mountedDone = true
  },
  computed: {
    isClient(){
    //   console.log("mm1 ?",this.$store.getters.master ,this.$store.getters.marsilli)
      return !this.$store.getters.marsilli
    },
    isMaster(){
    //   console.log("mm2 ?",this.$store.getters.master ,this.$store.getters.marsilli)
      return this.$store.getters.master
    },
    isAdmin(){
    //   console.log("mm3 ?",this.$store.getters.master ,this.$store.getters.marsilli)
      return this.$store.getters.master // && this.$store.getters.marsilli
    },
    isAmministrativo(){
    //   console.log("amm4 ?",this.$store.getters.amministrativo)
      return this.$store.getters.amministrativo
    },
    isReadonly(){
    //   console.log("ro5 ?",this.$store.getters.ro)
      return this.$store.getters.ro
    },
    frow(){ // ritorna le righe senza i campi nascosti (per la dialog)
      return !this.row ? null : this.row.filter(r => !this.hiddenField(r.key))
    },
    currclient(){
      if(!this.row) return null
      let t = this.row.find(r => r.key=='client_code')
      return t ? t.value : null
    },
    pagopts(){
      let perpage = localStorage.getItem("TabPerPage") || 10
      return {
                  enabled: true,
                  mode: 'records',
                  perPage: perpage*1,
                  position: 'top',
                  perPageDropdown: [5, 10, 20, 50, 100, 200, 500, 1000],
                  dropdownAllowAll: false,
                  setCurrentPage: 1,
                  nextLabel: 'next',
                  prevLabel: 'prev',
                  rowsPerPageLabel: 'Righe per pagina',
                  ofLabel: 'di',
                  pageLabel: 'pagina', // for 'pages' mode
                  allLabel: 'All',}
    },
    today() {
      var d = new Date(),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return [year, month, day].join("-");
    }
  },
  methods: {
    foptmacchine(currclient) {
        console.log({currclient})
        let opt = this.optmacchine.filter(r => (!currclient || r.client_code == currclient) && !!r.value)
        // le ordino e le rendo uniche
        opt = opt.sort((a,b) => a.value.localeCompare(b.value)).filter((v,i,a) => a.findIndex(v => v.value==a[i].value) == i)
        // opt = opt.sort((a,b) => a.value.localeCompare(b.value)).filter((v,i,a) => a.findIndex(v ) == i)
        console.log("foptmacchine", currclient, opt)
        return opt
    },
    onPageChange(params) {
      // params.currentPage - current page that pagination is at
      // params.currentPerPage - number of items per page
      // params.total - total number of items in the table
      console.log("OPC",params,this.mountedDone)
      if(this.mountedDone)
        localStorage.setItem("TabPerPage",params.currentPerPage)
    },
    countDownChanged(dismissCountDown) {
      this.saveerror = dismissCountDown;
    },
    getclient_code(v) {
      let o = this.optclients.find(o => o.value == v)
      return o ? o.text : "";
    },
    onMSelect(items) {
      console.log("ITEMS", items, this.row);
      this.row.forEach(function(r, i, a) {
        if (r.key == "cross") a[i].value = items;
      });
    },
    label(l) { // etichette nella tabella e nella form
      if (l == "id_progetto") return "Progetto";
      else if (l == "revnumb") return "Revis. Int.";
      else if (l == "client_code") return "Client";
      else if (l == "cnome") return "Cliente";
      else if (l == "amministrativo") return "Payment Status";
      else if (l == "ro") return "Read Only";
      else return l;
    },
    newRec() {
      this.row = [];
      this.columns.forEach(v => {
        var def = "";
        if (v.label == "data") def = this.today;
        if (v.label == "revnumb") def = "0";
        if (this.table == "clienti" && v.label == "codice")
          def = "C" + Date.now();
        if (
          (v.label!='industry' || this.table!='applications') &&
          (v.label!='Application' || this.table!='plant') &&
          (v.label!='Product Type' || this.table!='plant') &&
          v.label != "cnome" &&
          v.label != "id" &&
          v.label != "privacy" &&
          v.label != "updated" &&
          v.label != "inserted"
        )
        this.row.push({ key: v.field, value: def });
      });
      this.row.push({ key: "id", value: 0 });
      this.editModal = true;
    },
    async refresh() {
        this.waiting = true
        // opzioni per il multicombo uterep
        try {
            var resp = await API.getTabella("users_units");
            this.crossutemacchine = resp.rows.sort((a, b) => {
                if (a.user_id != b.user_id) return a.user_id - b.user_id
                return a.unit_code.localeCompare(b.unit_code)
            })
            // console.log("crossutemacchine", this.crossutemacchine)
            resp = await API.getPossibleUnits();
            // console.log("RESP", resp)
            this.optmacchine = resp.map(r => ({ text: r.code, value: r.code, client_code: r.client_code }))
            // console.log("optmacchine", this.optmacchine);
        } catch (e) {
            console.log("ERR", e);
        }

        let response = await API.getTabella(this.table)
        // console.log("RESPONSE", response)
        this.columns = response.fields.map(f => ({ label: f.name, field: f.name }));
        this.rows = response.rows;

        if (this.table == "users") {
            this.columns.push({
                label: "Units",
                field: "cross",
            });
            this.rows.forEach((r, j, a) => {
                var reps = this.crossutemacchine.filter(v => {
                    return v.user_id == r.id;
                });
                a[j].cross = reps.map(o => {
                    return this.optmacchine.filter(v => {
                        return v.value == o.unit_code;
                    })[0];
                }).filter(v => !!v);
            });
            this.columns = this.columns.filter(c => c.label!="amministrativo" || this.isMaster)
            this.columns = this.columns.filter(c => c.label!="ro" || this.isMaster)
            this.columns = this.columns.filter(c => !c.label.includes("_mail") || !this.isClient)
            this.columns = this.columns.filter(c => c.label!="privacy" || !this.isClient)
            // console.log("checkpoint2", this.rows,this.columns)
        }
        this.columns.push({ label: "actions", field: "actions" });
        this.waiting = false
    },
    // nascosti dalla form
    hiddenField(f) {
        var ret = (f == "id" || f == "updated" || f == "inserted" || f == "actions" || f == "attiva" || f == "hpt" || f == "hind" || f == "ha" || f == "privacy");
        if(this.isClient)
            ret = ret  || f.includes("_mail") // || f == "master"
        if(!this.isAdmin)
            ret = ret || f == "amministrativo"
        if(!this.isAdmin)
            ret = ret || f == "ro"
        return ret;
    },
    async saveentry() {
      console.log("ROW saveentry",this.row)
      var dato = this.row.reduce(function(a, c) {
        a[c.key] = c.value;
        return a;
      }, {});
      // console.log("DATO",dato)
      if(dato.data) {
        dato.data = dato.data.replace("T"," ").replace("Z","")
      }
      // eventualmente li elimino
      delete dato.actions;

      if (dato.id == 0) {
        delete dato.id
        let response = await API.setTabella(this.table, dato, false,'id')
        if (response.data.errno) {
            this.saveerror = 4;
            this.errordescr = response.data.message;
        } else {
            this.refresh();
        }
       } else {
         let response = await API.setTabella(this.table, dato, true,'id')
          if (response.data.errno) {
            this.saveerror = 4;
            this.errordescr = response.data.message;
          } else {
            this.refresh();
          }
      }
    },
    edit(row) {
      this.row = Object.entries(row.formattedRow).map(([key, value]) => ({
        key,
        value
      })).filter( r => r.key!='cnome')
      this.editModal = true;
    },
    delitem(id) {
      console.log("delitem",id)
      this.itemsel = id;
      this.dangerModal = true;
    },
    async deleteentry() {
      await API.delTabella(this.table,'id',this.itemsel)
      this.refresh();
    },
    onRowDoubleClick(params) {
      console.log("dblclick", params);
    },
    rowStyleClassFn() {
      return ""
    }
  }
};
</script>
<style scoped>
div.table table {
  width: 100%;
}
div.tabella {
  margin: 50px;
}
tr.green {
  background-color: lightgreen !important;
}
.multiple.search .delete.icon:before {
  font-family: sans-serif;
  content: "x";
  font-style: normal;
}
table button {
  fill: white;
}
button.add {
  fill: white;
}
span.cross {
    max-height: 100px;
    overflow-y: auto;
    height: 100px;
    display: inline-block;
}
</style>
